import { Tooltip } from '@material-ui/core';
import { ListaEventoRequest } from 'api/Assessor/evento';
import { AxiosError } from 'axios';
import { AlertIcon } from 'components/Icons';
import LayoutContext from 'components/Layout/LayoutContext';
import AddAttachment from 'components/Modal/AddAttachment';
import CloneEvent from 'components/Modal/CloneEvent';
import { EditarEventoModal } from 'components/Modal/EditarEventoModal';
import { QrCodeModal } from 'components/Modal/QrCodeModal';
import Description from 'components/__SHARED__/EllipsisWithTooltip/EllipsisWithTooltip';
import { AuthContext } from 'context/authContext/AuthContext';
import {
  AssemblyModalities,
  AssemblyModalityText,
  AssemblyType,
  ConvocationStatus,
  SituationText,
  SituationValues,
} from 'helpers/enums/Assembleia';
import { getProfileByJWTRoles } from 'helpers/utils/AuthUtils';
import ErrorHandler from 'helpers/utils/ErrorHandler';
import { clsx } from 'helpers/utils/HTMLUtils';
import {
  getParsedJWTAssessorAccessToken,
  JWTAssessorJson,
} from 'helpers/utils/JWTUtils';
import { getUniqueKey } from 'helpers/utils/KeyUtils';
import { languageValues } from 'helpers/utils/languageUtils';
import { toRequest } from 'helpers/utils/RequestUtils';
import {
  getAssembleiasAssessorBffEndpoint,
  getAssembleiasAssessorEndpoint,
} from 'library/Apis';
import {
  AssembleiaAssessorRoutePath,
  AssessorCadastroEventoRoutePath,
  AssessorCadastroReuniaoRoutePath,
  AssessorEditarVotosRoutePath,
  AssessorRelatoriosRoutePath,
  MensagensAssessorRoutePath,
  QuorumRoutePath,
  RelatorioPresentesRoutePath,
} from 'library/Routes';
import translation from 'locales/translation';
import moment from 'moment';
import {
  AssembleiasIcon,
  CheckCircleIcon,
  ClockIcon,
  Col,
  ConfirmModal,
  DestructiveModal,
  DropdownItem,
  DropdownMenu,
  EditIcon,
  ExclamationIcon,
  IconButton,
  MessageIcon,
  ModalSizes,
  OptionsIcon,
  Pagination,
  PercentLoaderIcon,
  Row,
  ScreenSize,
  TableWithOverflow,
  ToastTypes,
  TooltipPosition,
  useDropOpened,
} from 'plataforma-fundacao-componentes';
import {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useReducer,
  useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ApiService from 'services/ApiService';
import { assembleiasAssessorLoadEvento } from 'store/modules/AssembleiasAssessorActions';
import { IAssembleiasAssessorEvent } from 'store/modules/AssembleiasAssessorReducer';
import { assessorActionCarregarListaEventos } from 'store/modules/assessor/actions';
import {
  AuthUserPerfilId,
  IAuthUserPerfil,
} from 'store/modules/auth/IAuthUserPerfil';
import { closeModal, openModal } from 'store/modules/ModalActions';
import { IReducer } from 'store/Reducer';
import { initialEndDate, initialStartDate } from '../Filtros/reducer';
import { tableInitialState, tableReducer } from './reducer';
import styles from './styles.module.scss';

interface Props {
  filters: Partial<ListaEventoRequest> | undefined;
  hasDateError?: boolean;
}

const homePrefix = translation.Assessor.TelaInicial;
const infoAssemblyPrefix = translation.Assessor.Modal.InfoAssembly;

export default function HomeTable({ filters /* hasDateError */ }: Props) {
  const [iconLoader, setIconLoader] = useState<{
    loader: boolean;
    idEvent: number | null;
  }>({
    loader: false,
    idEvent: null,
  });
  const [qrLoading, setQrLoading] = useState<boolean>(false);

  const dispatch = useDispatch();
  const history = useHistory();
  const { usuario } = useSelector((state: IReducer) => state.auth);
  const { listaEventoIsLoading } = useSelector(
    (state: IReducer) => state.assessor
  );
  const [{ rows, page, count, totalElements }, action] = useReducer(
    tableReducer,
    tableInitialState
  );
  const { user } = useContext(AuthContext);

  const parsedToken: JWTAssessorJson | null = getParsedJWTAssessorAccessToken(
    user!.access_token
  );
  const perfil: IAuthUserPerfil | null = parsedToken
    ? getProfileByJWTRoles(parsedToken.roles)
    : null;

  const [dropOpened, toggleDropOpened] = useDropOpened<number | undefined>(
    undefined
  );

  let filtroStorage: string | null = sessionStorage.getItem('filter-assessor');
  let filtroObj: Partial<ListaEventoRequest> = JSON.parse(filtroStorage!);

  const { showToast } = useContext(LayoutContext);

  const modalEditarEvento = useCallback(
    (id: string | number, modalKey: any) => {
      return toRequest(
        ApiService.get,
        [`${getAssembleiasAssessorEndpoint('1')}evento/offline/${id}`],
        'assembleiaAssessorLodEvent'
      )
        .then((resp) => {
          const data: IAssembleiasAssessorEvent =
            resp.data as IAssembleiasAssessorEvent;

          dispatch(
            openModal(EditarEventoModal, {
              assembleiaId: id,
              assembleiaTitle: data?.nome,
              assembleiaDescription: data?.descricao,
              assembleiaDate: data?.dataEvento,
              assembleiaHour: data?.dataEvento,
              assembleiaDateEnd: data?.dataFimEvento,
              assembleiaHourEnd: data?.dataFimEvento,
              preventMaskExit: true,
              modalKey: modalKey,
              title: infoAssemblyPrefix.title,
              mobileOn: ScreenSize.xs,

              onClose: () => {
                dispatch(closeModal(modalKey));
              },
              onCancel: () => {
                dispatch(closeModal(modalKey));
              },
              onConfirm: () => {
                return new Promise<void>((resolve: any) => {
                  resolve();
                  dispatch(
                    assessorActionCarregarListaEventos(
                      { ...filters, page, size: 10 },
                      (listagem) => {
                        action({
                          type: 'setRows',
                          value: listagem.elements,
                        });
                        action({
                          type: 'setCount',
                          value: listagem.totalPages,
                        });
                      },
                      ErrorHandler
                    )
                  );
                  dispatch(closeModal(modalKey));
                });
              },
            })
          );
        })
        .catch((error) => {
          showToast({
            pauseOnFocusLoss: true,
            theme: ToastTypes.Error,
            showStatusBar: true,
            timeout: 4000,
            label: languageValues.toasts.error.keyErrors(
              error.response?.data.message
            ),
          });
        });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch, filters, page]
  );

  const deleteEvent = useCallback(
    (eventId: number, modalKey: string) =>
      new Promise<void>(() => {
        dispatch(
          openModal(DestructiveModal, {
            modalKey: modalKey,
            title: homePrefix.actions.deleteEvent,
            size: ModalSizes.Small,
            mobileOn: ScreenSize.xs,
            children: homePrefix.modals.deleteModal.message,
            language: {
              confirm: homePrefix.modals.deleteModal.buttons.confirm,
              cancel: homePrefix.modals.deleteModal.buttons.cancel,
            },
            onClose: () => {
              dispatch(closeModal(modalKey));
            },
            onCancel: () => {
              dispatch(closeModal(modalKey));
            },
            onConfirm: () => {
              return new Promise<void>((resolve: Function) => {
                ApiService.delete(
                  `${getAssembleiasAssessorBffEndpoint()}event/${eventId}`
                )
                  .then(() => {
                    resolve();
                    dispatch(
                      assessorActionCarregarListaEventos(
                        { ...filters, page, size: 10 },
                        (listagem) => {
                          action({
                            type: 'setRows',
                            value: listagem.elements,
                          });
                          action({
                            type: 'setCount',
                            value: listagem.totalPages,
                          });
                        },
                        ErrorHandler
                      )
                    );
                    dispatch(closeModal(modalKey));
                  })
                  .catch((error) => {
                    resolve();
                    showToast({
                      pauseOnFocusLoss: true,
                      theme: ToastTypes.Error,
                      showStatusBar: true,
                      timeout: 4000,
                      label:
                        translation.Toasts.Errors.Keys[
                          `${
                            (error as AxiosError<Error>).response?.data
                              .message ||
                            (error as AxiosError<Error>).response?.data ||
                            (error as AxiosError<Error>).message
                          }` as keyof typeof translation.Toasts.Errors.Keys
                        ] ?? homePrefix.modals.deleteModal.error,
                    });
                  });
              });
            },
          })
        );
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch, filters, page]
  );

  const cloneEvent = useCallback(
    (eventId: number, modalKey: string, modality: AssemblyModalities) =>
      new Promise<void>(() => {
        if (modality === AssemblyModalities.OFFLINE) {
          dispatch(
            openModal(ConfirmModal, {
              modalKey: modalKey,
              title: homePrefix.actions.clone,
              size: ModalSizes.Small,
              mobileOn: ScreenSize.xs,
              children: homePrefix.modals.cloneModal.message,
              onClose: () => {
                dispatch(closeModal(modalKey));
              },
              onCancel: () => {
                dispatch(closeModal(modalKey));
              },
              onConfirm: () => {
                return new Promise<void>((resolve: () => void) => {
                  toRequest(ApiService.post, [
                    `${getAssembleiasAssessorBffEndpoint()}event/clone`,
                    {
                      eventId: eventId,
                    },
                  ])
                    .then(({ data }) => {
                      if (data.hasError) {
                        showToast({
                          pauseOnFocusLoss: true,
                          theme: ToastTypes.Warning,
                          showStatusBar: true,
                          timeout: 10000,
                          label: homePrefix.modals.cloneModal.warning,
                        });
                      }
                      history.push(
                        `${AssessorCadastroEventoRoutePath}${data.event.id}/etapas/dados`
                      );
                      resolve();
                      dispatch(closeModal(modalKey));
                    })
                    .catch((error) => {
                      resolve();
                      showToast({
                        pauseOnFocusLoss: true,
                        theme: ToastTypes.Error,
                        showStatusBar: true,
                        timeout: 4000,
                        label:
                          translation.Toasts.Errors.Keys[
                            `${
                              (error as AxiosError<Error>).response?.data
                                .message ||
                              (error as AxiosError<Error>).response?.data ||
                              (error as AxiosError<Error>).message
                            }` as keyof typeof translation.Toasts.Errors.Keys
                          ] ?? translation.Toasts.Errors.defaultAlternative,
                      });
                    });
                });
              },
            })
          );
        } else {
          dispatch(
            openModal(CloneEvent, {
              eventId: eventId,
              modality: modality,
              modalKey: modalKey,
              preventMaskExit: true,
              title: homePrefix.actions.clone,
              size: ModalSizes.ExtraLarge,
              mobileOn: ScreenSize.xs,
              onClose: () => {
                dispatch(closeModal(modalKey));
              },
              onConfirm: (req) => {
                return new Promise<void>((resolve: (resp: any) => void) => {
                  resolve(req);
                });
              },
            })
          );
        }
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch]
  );

  const generateQrCode = useCallback(
    async (
      eventId: number,
      modalKey: string,
      survey?: boolean,
      modality?: AssemblyModalities
    ) => {
      if (survey) {
        dispatch(
          openModal(QrCodeModal, {
            modalKey: modalKey,
            title: homePrefix.modals.qrCodeModal.titleSurvey,
            prefix: homePrefix,
            preventMaskExit: true,
            mobileOn: ScreenSize.xs,
            eventId: eventId,
            survey: survey,
            modality: modality,
            onClose: () => {
              dispatch(closeModal(modalKey));
            },
            onCancel: () => {
              dispatch(closeModal(modalKey));
            },
            onConfirm: () => {
              dispatch(closeModal(modalKey));
            },
          })
        );
      } else {
        setQrLoading(true);

        return toRequest(ApiService.get, [
          `${getAssembleiasAssessorBffEndpoint(
            '1'
          )}event/with-steps/${eventId}`,
        ])
          .then((data) => {
            if (data.data.convocationStatus === ConvocationStatus.RUNNING) {
              showToast({
                pauseOnFocusLoss: true,
                theme: ToastTypes.Warning,
                showStatusBar: true,
                timeout: 10000,
                label: homePrefix.modals.qrCodeModal.warning,
              });
            } else {
              dispatch(
                openModal(QrCodeModal, {
                  modalKey: modalKey,
                  title: homePrefix.modals.qrCodeModal.title,
                  prefix: homePrefix,
                  preventMaskExit: true,
                  mobileOn: ScreenSize.xs,
                  eventId: eventId,
                  survey: false,
                  onClose: () => {
                    dispatch(closeModal(modalKey));
                  },
                  onCancel: () => {
                    dispatch(closeModal(modalKey));
                  },
                  onConfirm: () => {
                    dispatch(closeModal(modalKey));
                  },
                })
              );
            }
          })
          .catch((error) => {
            showToast({
              pauseOnFocusLoss: true,
              theme: ToastTypes.Error,
              showStatusBar: true,
              timeout: 4000,
              label: languageValues.toasts.error.keyErrors(
                error.response?.data.message
              ),
            });
          })
          .finally(() => {
            setQrLoading(false);
          });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch]
  );

  useEffect(() => {
    if (!filters) return;
    if (filters && filters.status?.length) {
      dispatch(
        assessorActionCarregarListaEventos(
          {
            ...filters,
            page,
            size: 10,
            idEvento: Number(
              filtroStorage !== null && filtroObj && filtroObj.idEvento
                ? filtroObj.idEvento
                : undefined
            ),
            dataInicial:
              filtroStorage !== null && filtroObj && filtroObj.dataInicial
                ? filtroObj.dataInicial
                : `${moment(initialStartDate, 'YYYY-MM-DD').format(
                    'YYYY-MM-DD'
                  )}T00:00:00`,
            dataFinal:
              filtroStorage !== null && filtroObj && filtroObj.dataFinal
                ? filtroObj.dataFinal
                : `${moment(initialEndDate, 'YYYY-MM-DD').format(
                    'YYYY-MM-DD'
                  )}T00:00:00`,
          },
          (listagem) => {
            action({
              type: 'setRows',
              value: listagem.elements,
            });
            action({ type: 'setCount', value: listagem.totalPages });
            action({ type: 'setTotalElements', value: listagem.totalElements });
          },
          (error: any) => {
            showToast({
              pauseOnFocusLoss: true,
              theme: ToastTypes.Error,
              showStatusBar: true,
              timeout: 4000,
              label:
                translation.Toasts.Errors.Keys[
                  `${
                    (error as AxiosError<Error>).response?.data.message ||
                    (error as AxiosError<Error>).response?.data ||
                    (error as AxiosError<Error>).message
                  }` as keyof typeof translation.Toasts.Errors.Keys
                ] ?? translation.Toasts.Errors.defaultAlternative,
            });
          }
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, filters, filters?.status, page]);

  useEffect(() => {
    action({
      type: 'setPage',
      value: 1,
    });
  }, [count]);

  const goToPage = (value: number) => {
    action({
      type: 'setPage',
      value,
    });
  };

  const tagTheme = (status: SituationValues) => {
    switch (status) {
      case SituationValues.EDITABLE:
        return styles.edicao;
      case SituationValues.RESERVABLE:
        return styles.reservado;
      case SituationValues.AVAILABLE:
        return styles.disponivel;
      case SituationValues.BLOCKED:
        return styles.bloqueado;
      case SituationValues.IN_PREPARATION:
        return styles.preparacao;
      case SituationValues.IN_ASSEMBLY:
        return styles.assembleia;
      case SituationValues.FINISHED:
        return styles.finalizado;
      case SituationValues.EXPIRED:
        return styles.expirado;
      default:
        return styles.default;
    }
  };

  const tagIcon = (status: SituationValues) => {
    switch (status) {
      case SituationValues.EDITABLE:
        return <EditIcon />;
      case SituationValues.RESERVABLE:
        return <ClockIcon />;
      case SituationValues.AVAILABLE:
        return <AlertIcon />;
      case SituationValues.BLOCKED:
        return <ExclamationIcon />;
      case SituationValues.IN_PREPARATION:
        return <CheckCircleIcon />;
      case SituationValues.IN_ASSEMBLY:
        return <CheckCircleIcon />;
      case SituationValues.FINISHED:
        return <CheckCircleIcon />;
      case SituationValues.EXPIRED:
        return <AlertIcon />;
      default:
        return <CheckCircleIcon />;
    }
  };

  const tooltipText = (status: SituationValues) => {
    switch (status) {
      case SituationValues.EDITABLE:
        return 'Assembleia em edição';
      case SituationValues.RESERVABLE:
        return 'Data da assembleia reservada';
      case SituationValues.AVAILABLE:
        return 'Assembleia cadastrada e disponível';
      case SituationValues.BLOCKED:
        return 'Assembleia cadastrada e bloqueada para edição';
      case SituationValues.IN_PREPARATION:
        return 'Assembleia logo começará ';
      case SituationValues.IN_ASSEMBLY:
        return 'Assembleia em andamento';
      case SituationValues.FINISHED:
        return 'Assembleia encerrada';
      case SituationValues.EXPIRED:
        return 'Assembleia expirada devido a falta de cadastramento';
      default:
        return 'Padrão';
    }
  };

  const showActionButton = (
    role: AuthUserPerfilId,
    allowedRole: AuthUserPerfilId[],
    status: SituationValues,
    allowedStatus: SituationValues[],
    type: AssemblyType,
    allowTypes: AssemblyType[]
  ) => {
    return (
      allowedRole.indexOf(role) > -1 &&
      allowedStatus.indexOf(status) > -1 &&
      allowTypes.indexOf(type) > -1
    );
  };

  const disableThreeDots = useMemo((): boolean => {
    if ([AuthUserPerfilId.PertencerChat].includes(perfil!?.id!)) {
      return true;
    }
    return false;
  }, [perfil]);

  const openAddAttachmentModal = useCallback(
    (eventId?: any) => {
      if (!eventId) return;
      const modalKey: string = getUniqueKey();

      dispatch(
        openModal(AddAttachment, {
          eventId: eventId,
          registeting: true,
          modalKey: modalKey,
          preventEscExit: true,
          preventMaskExit: true,
          readAndAddOnly: true,
          mobileOn: ScreenSize.xs,
          shouldUseBff: true,
          onClose: () => {
            // closeModal(Number);
          },
          onConfirm: () =>
            new Promise<void>(() => {
              // closeModal(Number);
            }),
        })
      );
    },
    [dispatch]
  );

  return (
    <Row className={styles.root}>
      <Col className={styles.table}>
        <TableWithOverflow
          showTopNavigator={false}
          noResultMessage={homePrefix.empty}
          columns={[
            {
              key: 'codEvento',
              value: homePrefix.tableHead.codEvento,
              props: {
                align: 'center',
                style: { minWidth: '100px', width: '100px' },
              },
            },
            {
              key: 'codCoop',
              value: homePrefix.tableHead.codCoop,
              props: {
                align: 'center',
                style: { minWidth: '100px', width: '100px' },
              },
            },
            {
              key: 'descricao',
              value: homePrefix.tableHead.descricao,
              props: {
                align: 'center',
                style: { minWidth: '150px' },
              },
            },
            {
              key: 'tipo',
              value: homePrefix.tableHead.tipo,
              props: {
                align: 'center',
                style: { minWidth: '70px', width: '70px' },
              },
            },
            {
              key: 'modo',
              value: homePrefix.tableHead.modo,
              props: {
                align: 'center',
                style: { minWidth: '20px', width: '20px' },
              },
            },
            {
              key: 'situacao',
              value: homePrefix.tableHead.situacao,
              props: {
                align: 'center',
                style: { minWidth: '200px', width: '200px' },
              },
            },
            {
              key: 'startDate',
              value: homePrefix.tableHead.startDate,
              props: {
                align: 'center',
              },
            },
            {
              key: 'endDate',
              value: homePrefix.tableHead.endDate,
              props: {
                align: 'center',
              },
            },
            {
              key: 'initialTime',
              value: homePrefix.tableHead.initialTime,
              props: {
                align: 'center',
                style: { minWidth: '100px', width: '100px' },
              },
            },
            {
              key: 'actions',
              value: homePrefix.tableHead.actions,
              props: { style: { minWidth: '100px', width: '100px' } },
            },
          ]}
          lines={rows.map((row) => {
            return {
              codEvento: row.id ?? '-',
              codCoop: row.codigoCooperativa ?? '-',
              descricao: (
                <Description
                  text={
                    row.flagEventoTeste
                      ? `(TESTE) ${row.titulo ?? '-'}`
                      : row.titulo ?? '-'
                  }
                  maxChars={35}
                  fontSize={14}
                  tooltip={true}
                  isTest={row.flagEventoTeste}
                />
              ),
              tipo: AssemblyType[
                row.tipo as unknown as keyof typeof AssemblyType
              ],
              modo: (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    width: '150px',
                    whiteSpace: 'normal',
                    overflowWrap: 'break-word',
                  }}
                >
                  {
                    AssemblyModalityText[
                      row.modo as unknown as keyof typeof AssemblyModalityText
                    ]
                  }
                </div>
              ),
              situacao: (
                <Tooltip
                  title={tooltipText(row.status)}
                  placement={'top'}
                  arrow
                >
                  <div className={styles.etiqueta_container}>
                    <div className={clsx([styles.etiquetas, styles.center])}>
                      <div
                        className={clsx([styles.theme, tagTheme(row.status)])}
                      >
                        {tagIcon(row.status)}
                        <span>
                          {
                            SituationText[
                              row.status! as unknown as keyof typeof SituationText
                            ]
                          }
                        </span>
                      </div>
                    </div>
                  </div>
                </Tooltip>
              ),
              startDate: row.inicio
                ? moment(row.inicio).format('DD/MM/YYYY')
                : '-',
              endDate: row.fim ? moment(row.fim).format('DD/MM/YYYY') : '-',
              initialTime: row.inicio
                ? moment(row.inicio).format('HH:mm')
                : '-',
              actions: (
                <div
                  style={{
                    display: 'flex',
                    gap: '16px',
                    width: '100%',
                    justifyContent: 'flex-end',
                  }}
                >
                  <IconButton
                    data-testid={`assessor-evento-botoes-assembleia-${row.id}`}
                    color={'primary'}
                    tooltip-text={
                      perfil && perfil.id === AuthUserPerfilId.PertencerChat
                        ? homePrefix.actionMensagens
                        : homePrefix.actionEvento
                    }
                    tooltip-position={TooltipPosition.Bottom}
                    disabled={
                      [
                        SituationValues.EDITABLE,
                        SituationValues.RESERVABLE,
                        SituationValues.EXPIRED,
                      ].includes(row.status) ||
                      row.modo === AssemblyModalities.OFFLINE
                        ? true
                        : perfil && perfil.id === AuthUserPerfilId.PertencerChat
                        ? false
                        : !usuario?.perfil.assessorRoute.assembleias.ver
                    }
                    onClick={() => {
                      if (
                        perfil &&
                        perfil.id === AuthUserPerfilId.PertencerChat
                      ) {
                        history.push(
                          MensagensAssessorRoutePath.replace(
                            ':idEvento',
                            row.id.toString()
                          )
                        );
                      } else {
                        setIconLoader({
                          loader: true,
                          idEvent: row.id,
                        });
                        dispatch(
                          assembleiasAssessorLoadEvento(
                            row.id,
                            () => {
                              setIconLoader({
                                loader: false,
                                idEvent: null,
                              });
                              history.push(
                                AssembleiaAssessorRoutePath.replace(
                                  ':id',
                                  row.id.toString()
                                )
                              );
                            },
                            (error) => {
                              setIconLoader({
                                loader: false,
                                idEvent: null,
                              });

                              showToast({
                                pauseOnFocusLoss: true,
                                theme:
                                  error.response?.data.message ===
                                  'event.convocationIsRunning'
                                    ? ToastTypes.Warning
                                    : ToastTypes.Error,
                                showStatusBar: true,
                                timeout: 6000,
                                label:
                                  translation.Toasts.Errors.Keys[
                                    `${
                                      error.response?.data.message ||
                                      error.response?.data ||
                                      error.message
                                    }` as keyof typeof translation.Toasts.Errors.Keys
                                  ] ??
                                  translation.Toasts.Errors.defaultAlternative,
                              });
                            }
                          )
                        );
                      }
                    }}
                    icon={
                      perfil && perfil.id === AuthUserPerfilId.PertencerChat ? (
                        <MessageIcon />
                      ) : row.id === iconLoader.idEvent && iconLoader.loader ? (
                        <PercentLoaderIcon indefinido />
                      ) : (
                        <AssembleiasIcon />
                      )
                    }
                  />

                  <DropdownMenu
                    data-testid={`assessor-evento-pontinhos-${row.id}`}
                    opened={String(dropOpened) === String(row.id)}
                    setOpened={(val) => toggleDropOpened(row.id, val)}
                    content={
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        {usuario !== undefined &&
                        showActionButton(
                          usuario.perfil.id,
                          [
                            AuthUserPerfilId.PertencerAdmin,
                            AuthUserPerfilId.PertencerGestao,
                            AuthUserPerfilId.PertencerConsulta,
                          ],
                          row.status,
                          [
                            SituationValues.EDITABLE,
                            SituationValues.AVAILABLE,
                            SituationValues.BLOCKED,
                            SituationValues.IN_PREPARATION,
                            SituationValues.IN_ASSEMBLY,
                            SituationValues.RESERVABLE,
                            SituationValues.FINISHED,
                          ],
                          row.tipo,
                          [
                            AssemblyType.AGE,
                            AssemblyType.AGN,
                            AssemblyType.AGO,
                            AssemblyType.AOE,
                            AssemblyType.REU,
                          ]
                        ) ? (
                          <DropdownItem
                            label={
                              row.modo === AssemblyModalities.OFFLINE &&
                              row.status === SituationValues.FINISHED &&
                              usuario.perfil.id ===
                                AuthUserPerfilId.PertencerAdmin
                                ? homePrefix.actions.edit
                                : [
                                    AuthUserPerfilId.PertencerAdmin,
                                    AuthUserPerfilId.PertencerGestao,
                                  ].indexOf(usuario.perfil.id) > -1
                                ? [
                                    SituationValues.EDITABLE,
                                    SituationValues.RESERVABLE,
                                  ].includes(row.status)
                                  ? homePrefix.actions.edit
                                  : [
                                      SituationValues.AVAILABLE,
                                      SituationValues.RESERVABLE,
                                      SituationValues.IN_PREPARATION,
                                    ].includes(row.status) ||
                                    (AssemblyModalities.OFFLINE === row.modo &&
                                      ((SituationValues.FINISHED ===
                                        row.status &&
                                        AuthUserPerfilId.PertencerAdmin ===
                                          usuario.perfil.id) ||
                                        SituationValues.BLOCKED === row.status))
                                  ? homePrefix.actions.viewEdit
                                  : homePrefix.actions.view
                                : [
                                    SituationValues.EDITABLE,
                                    SituationValues.RESERVABLE,
                                  ].includes(row.status) &&
                                  usuario.perfil.id ===
                                    AuthUserPerfilId.PertencerConsulta &&
                                  AssemblyType.REU === row.tipo
                                ? homePrefix.actions.edit
                                : (usuario.perfil.id ===
                                    AuthUserPerfilId.PertencerConsulta &&
                                    [
                                      SituationValues.AVAILABLE,
                                      SituationValues.IN_PREPARATION,
                                    ].includes(row.status) &&
                                    AssemblyType.REU === row.tipo) ||
                                  ([SituationValues.BLOCKED].includes(
                                    row.status
                                  ) &&
                                    AssemblyType.REU === row.tipo &&
                                    [AssemblyModalities.OFFLINE].includes(
                                      row.modo
                                    ))
                                ? homePrefix.actions.viewEdit
                                : homePrefix.actions.view
                            }
                            onClick={() => {
                              toggleDropOpened(row.id, false);
                              if (
                                [
                                  SituationValues.BLOCKED,
                                  SituationValues.IN_ASSEMBLY,
                                  SituationValues.FINISHED,
                                ].indexOf(row.status) > -1 &&
                                [
                                  AssemblyModalities.ONLINE,
                                  AssemblyModalities.HIBRIDO_DIGITAL_AGENCIA,
                                  AssemblyModalities.HIBRIDO_PRESENCIAL_DIGITAL,
                                  AssemblyModalities.HIBRIDO_SIMULTANEO,
                                ].indexOf(row.modo) > -1
                              ) {
                                if (row.tipo === AssemblyType.REU) {
                                  history.push(
                                    `${AssessorCadastroReuniaoRoutePath}${row.id}/etapas/dados`
                                  );
                                } else {
                                  history.push(
                                    `${AssessorCadastroEventoRoutePath}${row.id}/etapas/dados`
                                  );
                                }
                              } else if (
                                row.modo === AssemblyModalities.OFFLINE &&
                                row.status === SituationValues.FINISHED &&
                                usuario.perfil.id ===
                                  AuthUserPerfilId.PertencerAdmin
                              ) {
                                const mKey = `alert${getUniqueKey()}`;
                                modalEditarEvento(row.id, mKey);
                              } else {
                                if (row.tipo === AssemblyType.REU) {
                                  history.push(
                                    `${AssessorCadastroReuniaoRoutePath}${row.id}/etapas/dados`
                                  );
                                } else {
                                  history.push(
                                    `${AssessorCadastroEventoRoutePath}${row.id}/etapas/dados`
                                  );
                                }
                              }
                            }}
                          />
                        ) : undefined}
                        {usuario !== undefined &&
                        [AssemblyModalities.OFFLINE].includes(row.modo) &&
                        (showActionButton(
                          usuario.perfil.id,
                          [
                            AuthUserPerfilId.PertencerAdmin,
                            AuthUserPerfilId.PertencerGestao,
                          ],
                          row.status,
                          [SituationValues.FINISHED],
                          row.tipo,
                          [
                            AssemblyType.AGE,
                            AssemblyType.AGN,
                            AssemblyType.AGO,
                            AssemblyType.AOE,
                            AssemblyType.REU,
                          ]
                        ) ||
                          showActionButton(
                            usuario.perfil.id,
                            [AuthUserPerfilId.PertencerConsulta],
                            row.status,
                            [SituationValues.FINISHED],
                            row.tipo,
                            [AssemblyType.REU]
                          )) ? (
                          <DropdownItem
                            label={homePrefix.actions.attachment}
                            onClick={() => {
                              openAddAttachmentModal(row.id);
                              toggleDropOpened(row.id, false);
                            }}
                          />
                        ) : undefined}
                        {usuario !== undefined &&
                        (showActionButton(
                          usuario.perfil.id,
                          [
                            AuthUserPerfilId.PertencerAdmin,
                            AuthUserPerfilId.PertencerGestao,
                          ],
                          row.status,
                          [
                            SituationValues.EDITABLE,
                            SituationValues.AVAILABLE,
                            SituationValues.BLOCKED,
                            SituationValues.IN_PREPARATION,
                            SituationValues.IN_ASSEMBLY,
                            SituationValues.FINISHED,
                            SituationValues.RESERVABLE,
                          ],
                          row.tipo,
                          [
                            AssemblyType.AGE,
                            AssemblyType.AGN,
                            AssemblyType.AGO,
                            AssemblyType.AOE,
                            AssemblyType.REU,
                          ]
                        ) ||
                          showActionButton(
                            usuario.perfil.id,
                            [AuthUserPerfilId.PertencerConsulta],
                            row.status,
                            [
                              SituationValues.EDITABLE,
                              SituationValues.AVAILABLE,
                              SituationValues.BLOCKED,
                              SituationValues.IN_PREPARATION,
                              SituationValues.IN_ASSEMBLY,
                              SituationValues.FINISHED,
                            ],
                            row.tipo,
                            [AssemblyType.REU]
                          )) ? (
                          <DropdownItem
                            label={homePrefix.actions.clone}
                            onClick={() => {
                              const mKey = `alert${getUniqueKey()}`;
                              cloneEvent(row.id, mKey, row.modo);
                              toggleDropOpened(row.id, false);
                            }}
                          />
                        ) : undefined}
                        {usuario !== undefined &&
                        [
                          AssemblyModalities.ONLINE,
                          AssemblyModalities.HIBRIDO_PRESENCIAL_DIGITAL,
                          AssemblyModalities.HIBRIDO_DIGITAL_AGENCIA,
                          AssemblyModalities.HIBRIDO_SIMULTANEO,
                        ].includes(row.modo) &&
                        (showActionButton(
                          usuario.perfil.id,
                          [
                            AuthUserPerfilId.PertencerAdmin,
                            AuthUserPerfilId.PertencerGestao,
                          ],
                          row.status,
                          [
                            SituationValues.IN_PREPARATION,
                            SituationValues.AVAILABLE,
                            SituationValues.IN_ASSEMBLY,
                            SituationValues.FINISHED,
                          ],
                          row.tipo,
                          [
                            AssemblyType.AGE,
                            AssemblyType.AGN,
                            AssemblyType.AGO,
                            AssemblyType.AOE,
                            AssemblyType.REU,
                          ]
                        ) ||
                          showActionButton(
                            usuario.perfil.id,
                            [AuthUserPerfilId.PertencerConsulta],
                            row.status,
                            [
                              SituationValues.FINISHED,
                              SituationValues.IN_ASSEMBLY,
                              SituationValues.IN_PREPARATION,
                              SituationValues.AVAILABLE,
                            ],
                            row.tipo,
                            [AssemblyType.REU]
                          )) ? (
                          <DropdownItem
                            label={homePrefix.actions.messages}
                            onClick={() => {
                              history.push(
                                MensagensAssessorRoutePath.replace(
                                  ':idEvento',
                                  row.id.toString()
                                )
                              );
                            }}
                          />
                        ) : undefined}
                        {usuario !== undefined &&
                        [
                          AssemblyModalities.ONLINE,
                          AssemblyModalities.HIBRIDO_PRESENCIAL_DIGITAL,
                          AssemblyModalities.HIBRIDO_DIGITAL_AGENCIA,
                          AssemblyModalities.HIBRIDO_SIMULTANEO,
                        ].includes(row.modo) &&
                        showActionButton(
                          usuario.perfil.id,
                          [
                            AuthUserPerfilId.PertencerAdmin,
                            AuthUserPerfilId.PertencerGestao,
                            AuthUserPerfilId.PertencerConsulta,
                          ],
                          row.status,
                          [SituationValues.FINISHED],
                          row.tipo,
                          [
                            AssemblyType.AGE,
                            AssemblyType.AGN,
                            AssemblyType.AGO,
                            AssemblyType.AOE,
                            AssemblyType.REU,
                          ]
                        ) ? (
                          <DropdownItem
                            label={homePrefix.actions.quorum}
                            onClick={() => {
                              history.push(
                                QuorumRoutePath.replace(
                                  ':idAssembleia',
                                  row.id.toString()
                                )
                              );
                            }}
                          />
                        ) : undefined}
                        {usuario !== undefined &&
                        [
                          AssemblyModalities.ONLINE,
                          AssemblyModalities.HIBRIDO_PRESENCIAL_DIGITAL,
                          AssemblyModalities.HIBRIDO_DIGITAL_AGENCIA,
                          AssemblyModalities.HIBRIDO_SIMULTANEO,
                        ].includes(row.modo) &&
                        showActionButton(
                          usuario.perfil.id,
                          [
                            AuthUserPerfilId.PertencerAdmin,
                            AuthUserPerfilId.PertencerGestao,
                            AuthUserPerfilId.PertencerConsulta,
                          ],
                          row.status,
                          [SituationValues.FINISHED],
                          row.tipo,
                          [
                            AssemblyType.AGE,
                            AssemblyType.AGN,
                            AssemblyType.AGO,
                            AssemblyType.AOE,
                            AssemblyType.REU,
                          ]
                        ) ? (
                          <DropdownItem
                            label={homePrefix.actions.presenceList}
                            onClick={() => {
                              history.push(
                                RelatorioPresentesRoutePath.replace(
                                  ':idAssembleia',
                                  row.id.toString()
                                )
                              );
                            }}
                          />
                        ) : undefined}
                        {usuario !== undefined &&
                        [AssemblyModalities.OFFLINE].includes(row.modo) &&
                        (showActionButton(
                          usuario.perfil.id,
                          [
                            AuthUserPerfilId.PertencerAdmin,
                            AuthUserPerfilId.PertencerGestao,
                          ],
                          row.status,
                          [SituationValues.FINISHED],
                          row.tipo,
                          [
                            AssemblyType.AGE,
                            AssemblyType.AGN,
                            AssemblyType.AGO,
                            AssemblyType.AOE,
                            AssemblyType.REU,
                          ]
                        ) ||
                          showActionButton(
                            usuario.perfil.id,
                            [AuthUserPerfilId.PertencerConsulta],
                            row.status,
                            [SituationValues.FINISHED],
                            row.tipo,
                            [AssemblyType.REU]
                          )) ? (
                          <DropdownItem
                            label={homePrefix.actions.votes}
                            onClick={() => {
                              history.push(
                                AssessorEditarVotosRoutePath.replace(
                                  ':id',
                                  row.id.toString()
                                )
                              );
                              toggleDropOpened(row.id, false);
                            }}
                          />
                        ) : undefined}
                        {usuario !== undefined &&
                        [
                          AssemblyModalities.OFFLINE,
                          AssemblyModalities.HIBRIDO_PRESENCIAL_DIGITAL,
                        ].indexOf(row.modo) > -1 &&
                        (showActionButton(
                          usuario.perfil.id,
                          [
                            AuthUserPerfilId.PertencerAdmin,
                            AuthUserPerfilId.PertencerGestao,
                          ],
                          row.status,
                          [SituationValues.AVAILABLE, SituationValues.BLOCKED],
                          row.tipo,
                          [
                            AssemblyType.AGE,
                            AssemblyType.AGN,
                            AssemblyType.AGO,
                            AssemblyType.AOE,
                            AssemblyType.REU,
                          ]
                        ) ||
                          showActionButton(
                            usuario.perfil.id,
                            [AuthUserPerfilId.PertencerConsulta],
                            row.status,
                            [
                              SituationValues.AVAILABLE,
                              SituationValues.BLOCKED,
                            ],
                            row.tipo,
                            [AssemblyType.REU]
                          )) ? (
                          <DropdownItem
                            label={homePrefix.actions.qrCode}
                            onClick={() => {
                              const mKey = `alert${getUniqueKey()}`;
                              generateQrCode(row.id, mKey, false).finally(() =>
                                setTimeout(() => {
                                  toggleDropOpened(row.id, false);
                                }, 100)
                              );
                            }}
                            loading={qrLoading}
                          />
                        ) : undefined}
                        {usuario !== undefined &&
                        [
                          AssemblyModalities.OFFLINE,
                          AssemblyModalities.HIBRIDO_PRESENCIAL_DIGITAL,
                          AssemblyModalities.HIBRIDO_SIMULTANEO,
                          AssemblyModalities.HIBRIDO_DIGITAL_AGENCIA,
                        ].includes(row.modo) &&
                        row.flagPesquisa &&
                        showActionButton(
                          usuario.perfil.id,
                          [
                            AuthUserPerfilId.PertencerAdmin,
                            AuthUserPerfilId.PertencerGestao,
                          ],
                          row.status,
                          [
                            SituationValues.AVAILABLE,
                            SituationValues.IN_ASSEMBLY,
                            SituationValues.IN_PREPARATION,
                            SituationValues.BLOCKED,
                          ],
                          row.tipo,
                          [AssemblyType.AGN]
                        ) ? (
                          <DropdownItem
                            label={homePrefix.actions.qrCodeSurvey}
                            onClick={() => {
                              const mKey = `alert${getUniqueKey()}`;
                              generateQrCode(
                                row.id,
                                mKey,
                                true,
                                row.modo
                              ).finally(() =>
                                setTimeout(() => {
                                  toggleDropOpened(row.id, false);
                                }, 100)
                              );
                            }}
                          />
                        ) : undefined}
                        {usuario !== undefined &&
                        showActionButton(
                          usuario.perfil.id,
                          [
                            AuthUserPerfilId.PertencerAdmin,
                            AuthUserPerfilId.PertencerGestao,
                            AuthUserPerfilId.PertencerConsulta,
                            AuthUserPerfilId.PertencerChat,
                          ],
                          row.status,
                          [
                            SituationValues.AVAILABLE,
                            SituationValues.BLOCKED,
                            SituationValues.IN_PREPARATION,
                            SituationValues.IN_ASSEMBLY,
                            SituationValues.FINISHED,
                          ],
                          row.tipo,
                          [
                            AssemblyType.AGE,
                            AssemblyType.AGN,
                            AssemblyType.AGO,
                            AssemblyType.AOE,
                            AssemblyType.REU,
                          ]
                        ) ? (
                          <DropdownItem
                            label={homePrefix.actions.relatory}
                            onClick={() => {
                              window.open(
                                AssessorRelatoriosRoutePath.replace(
                                  ':id',
                                  row.id.toString()
                                ),
                                '_blank'
                              );

                              toggleDropOpened(row.id, true);
                            }}
                          />
                        ) : undefined}
                        {(usuario !== undefined &&
                          usuario.perfil.id ===
                            AuthUserPerfilId.PertencerGestao &&
                          showActionButton(
                            usuario.perfil.id,
                            [AuthUserPerfilId.PertencerGestao],
                            row.status,
                            [
                              SituationValues.AVAILABLE,
                              SituationValues.EDITABLE,
                              SituationValues.RESERVABLE,
                              SituationValues.EXPIRED,
                            ],
                            row.tipo,
                            [
                              AssemblyType.AGE,
                              AssemblyType.AGN,
                              AssemblyType.AGO,
                              AssemblyType.AOE,
                              AssemblyType.REU,
                            ]
                          )) ||
                        showActionButton(
                          usuario!?.perfil.id,
                          [AuthUserPerfilId.PertencerAdmin],
                          row.status,
                          [
                            SituationValues.EDITABLE,
                            SituationValues.AVAILABLE,
                            SituationValues.BLOCKED,
                            SituationValues.IN_PREPARATION,
                            SituationValues.IN_ASSEMBLY,
                            SituationValues.FINISHED,
                            SituationValues.EXPIRED,
                            SituationValues.RESERVABLE,
                          ],
                          row.tipo,
                          [
                            AssemblyType.AGE,
                            AssemblyType.AGN,
                            AssemblyType.AGO,
                            AssemblyType.AOE,
                            AssemblyType.REU,
                          ]
                        ) ||
                        showActionButton(
                          usuario!?.perfil.id,
                          [AuthUserPerfilId.PertencerAdmin],
                          row.status,
                          [SituationValues.FINISHED],
                          row.tipo,
                          [AssemblyType.REU]
                        ) ||
                        showActionButton(
                          usuario!?.perfil.id,
                          [AuthUserPerfilId.PertencerConsulta],
                          row.status,
                          [
                            SituationValues.EDITABLE,
                            SituationValues.EXPIRED,
                            SituationValues.RESERVABLE,
                            SituationValues.AVAILABLE,
                          ],
                          row.tipo,
                          [AssemblyType.REU]
                        ) ? (
                          <DropdownItem
                            label={homePrefix.actions.deleteEvent}
                            onClick={() => {
                              const mKey = `alert${getUniqueKey()}`;
                              toggleDropOpened(row.id, false);
                              deleteEvent(row.id, mKey);
                            }}
                          />
                        ) : undefined}
                      </div>
                    }
                  >
                    <IconButton
                      className={styles.option_icon}
                      icon={<OptionsIcon />}
                      disabled={
                        disableThreeDots ||
                        ([AuthUserPerfilId.PertencerConsulta].includes(
                          perfil!?.id!
                        ) &&
                          row.status === SituationValues.EXPIRED &&
                          row.tipo !== AssemblyType.REU)
                      }
                      onClick={() => {
                        toggleDropOpened(row.id, dropOpened !== row.id);
                      }}
                    />
                  </DropdownMenu>
                </div>
              ),
            };
          })}
        />
      </Col>
      {totalElements >= 1 ? (
        <Col className={styles.paginationContainer}>
          <Pagination
            totalPages={count}
            currentPage={page}
            onPageChange={(_, val) => {
              goToPage(val);
            }}
            loading={listaEventoIsLoading}
            countPages={{
              rows: 10,
              totalItems: totalElements,
            }}
          />
        </Col>
      ) : undefined}
    </Row>
  );
}
